import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue, FctValue24, FctValue160 } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { SWAP_ROUTER_02_ADDRESSES } from '../helpers/constants';
export var ExactInputSingleSwapRouter02 = createPlugin({
    protocol: 'UNISWAP_V3',
    type: 'ACTION',
    method: 'exactInputSingle',
    name: 'snipper_swap_router_02',
    supportedContracts: SWAP_ROUTER_02_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    params_tuple: {
                        tokenIn: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                        tokenOut: new FctAddress({ destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                        fee: new FctValue24({ options: [{ value: '500', name: '0.05%' }, { value: '3000', name: '0.3%' }, { value: '10000', name: '1%' }] }),
                        recipient: new FctAddress({}),
                        amountIn: new FctValue({ destination: 'wei_amount' }),
                        amountOutMinimum: new FctValue({ destination: 'wei_amount' }),
                        sqrtPriceLimitX96: new FctValue160({}),
                    },
                },
            },
            output: {
                amountOut: new FctValue({}),
            },
        });
    },
    initParams: {
        methodParams: {
            params_tuple: {
                fee: '3000',
                amountOutMinimum: '0',
                sqrtPriceLimitX96: '0',
            },
        },
    },
    requiredApprovals: function (params) {
        var tokenIn = params.methodParams['params_tuple'].tokenIn;
        if (!tokenIn.value || typeof tokenIn.value !== 'string')
            return [];
        return [
            {
                to: tokenIn.value,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amountIn.value },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
});
